/* eslint-disable no-unused-vars */
import VendorHome from '../views/vendor/VendorHome.vue'
import VendorPerusahaan from '../views/vendor/VendorPerusahaan.vue'
import VendorIjin from '../views/vendor/VendorIjin.vue'
import VendorAkta from '../views/vendor/VendorAkta.vue'
import VendorPemilik from '../views/vendor/VendorPemilik.vue'
import VendorPengurus from '../views/vendor/VendorPengurus.vue'
import VendorPengalaman from '../views/vendor/VendorPengalaman.vue'
import VendorPajak from '../views/vendor/VendorPajak.vue'


const vendor = [  
  {
    path: '/vendor',
    component: VendorHome,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/vendor/perusahaan',
    component: VendorPerusahaan,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/vendor/ijin',
    component: VendorIjin,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/vendor/akta',
    component: VendorAkta,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/vendor/pemilik',
    component: VendorPemilik,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/vendor/pengurus',
    component: VendorPengurus,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/vendor/pengalaman',
    component: VendorPengalaman,
    meta: { auth: true, vendor: true }    
  },
  {
    path: '/vendor/pajak',
    component: VendorPajak,
    meta: { auth: true, vendor: true }    
  }
]

export default vendor